import { BoardEditor, FullModal, IBoard, IBoardStyle, createBoard, useToasts } from '@vestaboard/installables'
import React, { useState } from 'react'

import { Box } from '@material-ui/core'
import { Checkbox } from '../../../ui/Checkbox'
import { useCreateMessage } from '../hooks/useCreateMessage'

interface ICreateMessageModalProps {
  onClose: () => void
  onSaved: (message: {
    id: string
    text: string | null
    tags: string[]
    characters: Array<number[]> | null
    createdAt: number
    cardSize?: string
  }) => void
  boardStyle?: string
  initialCharacters?: Array<number[]>
}

export const CreateMessageModal = (props: ICreateMessageModalProps) => {
  const [isNote, setIsNote] = useState(props?.boardStyle?.includes('note') || false)
  const [createMessage] = useCreateMessage()
  const [value, setValue] = useState<IBoard>(
    (props.initialCharacters as IBoard) ||
      createBoard({
        rows: props.boardStyle === 'note-black' ? 3 : 6,
        columns: props.boardStyle === 'note-black' ? 15 : 22
      })
  )
  const { addToast } = useToasts()

  return (
    <FullModal onClose={props.onClose}>
      <Box>
        <Box style={{ marginBottom: '12px', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <Checkbox
            checked={!isNote}
            label='Flagship'
            handleCheck={() => {
              setIsNote(false)
              setValue(createBoard())
            }}
            color='secondary'
          />
          <Box width={12} />
          <Checkbox
            checked={isNote}
            label='Note'
            handleCheck={() => {
              setIsNote(true)
              setValue(
                createBoard({
                  rows: 3,
                  columns: 15
                })
              )
            }}
            color='secondary'
          />
        </Box>
        <BoardEditor
          mode={props.initialCharacters ? 'paint' : undefined}
          boardStyle={isNote ? 'note-black' : (props.boardStyle as IBoardStyle)}
          boardValue={value}
          setBoardValue={setValue}
          sendButtonLabel='Save'
          showFilledColor
          onSend={async () => {
            const response = await createMessage({
              variables: {
                input: {
                  characters: value
                }
              }
            })

            if (response.data?.createMessage.__typename === 'MessageV2') {
              props.onSaved({
                id: response.data.createMessage.id,
                text: response.data.createMessage.text,
                characters: response.data.createMessage.characters,
                createdAt: response.data.createMessage.createdAt,
                tags: response.data.createMessage.tags || [],
                cardSize: response.data.createMessage.cardSize
              })
              props.onClose()
            } else {
              addToast(response.data?.createMessage.error || 'There was an error creating your message', {
                appearance: 'error'
              })
            }
          }}
        />
      </Box>
    </FullModal>
  )
}
